import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { CommonService } from "../../../services/common.service";
// import { start } from "repl";

@Component({
  selector: "app-insurance-master",
  templateUrl: "./insurance-master.component.html",
  styleUrls: ["./insurance-master.component.css"]
})
export class InsuranceMasterComponent implements OnInit {
  actionmode: string = "Search";
  showList: boolean = false;
  screen_details: any = [];
  searchlist: boolean = false;

  validflag = false;
  validflagform = {};

  editFlag: any = false;
  screentitle: string = "Insurance Master";
  search_details: any = [];
  viewpage = false;
  searchresult = false;
  searchtabledata: any = [];
  loader: any = false;
  parent_table = "mst_insurance";

  childtables = [];
  EditData: any = [];
  filters = [];
  delete_id = "";
  screen_name = "zero_canc";
  providers: any = [
    { "map_id": "0", "value": "None" },
    { "map_id": "1", "value": "ICICI Lombard" },
    { "map_id": "2", "value": "BRB" },
    { "map_id": "3", "value": "LGI" }
  ]
  dbFields = [
    "TRAVEL_START", "TRAVEL_END", "COST_PRICE", "COST_PRICE_NO_GST", "MARKUP", "PLOUGHBACK", "RPM"
    , "COMMISSION", "SCREEN_NAME", "TRIP_TYPE", "INSURANCE_PROVIDER"
    // this.APPLICABLE_FROM,
    // this.APPLICABLE_TO
    // this.IS_LOGIN
  ];
  custom_header = "";
  custom_msg = "";
  constructor(private vernostService: VernostServiceService, private commonService: CommonService) { }
  ngOnInit() {
    this.screen_details.Cost_Price_No_GST = null;
    var Data = {
      parent_table: "UB_MST_INSURANCE_PROVIDER",
      dbFields: ["1"],
      searchData: ["1"],
      childtables: this.childtables,
      filters: this.filters
    };
    this.vernostService.searchRecord(Data).subscribe(response => {
      this.searchDataOnLoad();
      // console.log("ins prov:",response)
      if (response.length > 0) {
        this.providers = response
      }
    })
  }

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
    this.validflag = false;
    this.validflagform = {};
    if (this.screen_name != 'zero_canc') {
      this.screen_details.Trip_Type = '';
      this.screen_details.Insurance_Provider = '';
    }
  }

  searchForm(show_error_msg) {
    this.actionmode = "Search";
    this.screen_details = [];
    this.editFlag = false;
    document.getElementById("errs").innerHTML = "";
    this.viewpage = false;
    // this.search_details = [];
    this.searchData(show_error_msg);
  }
  submitcancelData() {
    console.log("this.screen_details", this.screen_details);
    this.validate()
    let id;
    if (this.EditData.length > 0) {
      id = this.EditData[0]["ID"];
    }

    var formData = [
      (this.screen_details.Travel_Start_Date == undefined || this.screen_details.Travel_Start_Date == null) ? "" : this.screen_details.Travel_Start_Date,
      (this.screen_details.Travel_End_Date == undefined || this.screen_details.Travel_End_Date == null) ? "" : this.screen_details.Travel_End_Date,
      this.screen_details.Cost_Price,
      this.screen_details.Cost_Price_No_GST,
      this.screen_details.Mark_Up = this.screen_details.Mark_Up == null ? "" : this.screen_details.Mark_Up,
      this.screen_details.Ploughback,
      this.screen_details.RPM,
      this.screen_details.Commission,
      this.screen_name,
      (this.screen_details.Trip_Type == undefined) ? "" : this.screen_details.Trip_Type,
      (this.screen_details.Insurance_Provider == null) ? "" : this.screen_details.Insurance_Provider
    ];

    if (this.editFlag == false) {
      this.checkRecordInDB().then(isRecordInDB => {
        if (!isRecordInDB) {
          console.log("checkRecordInDB():", isRecordInDB);
          var Data = {
            parent_table: this.parent_table,
            dbFields: this.dbFields,
            formData: formData,
            // USER_ID: this.uid,
            PAGENAME: "BANNER"
          };

          this.vernostService.insertData(Data).subscribe(response => {
            console.log("insert:", response)
            if (response[0].message == "Data inserted") {
              this.removeEditScreen();
              // document.getElementById("errs").innerHTML =
              //   "Record Created Successfully";
              this.showMessagePopup("Record Inserted Successfully");
              this.screen_details = [];
              this.validflag = false;

            } else {
              // document.getElementById("errs").innerHTML = 
              this.showMessagePopup("Record Not Inserted Successfully");
            }
          });
        }
      })
    }
    if (this.editFlag == true) {
      var array = {
        parent_table: this.parent_table,
        dbFields: this.dbFields,
        parent_table_ID: "ID",
        formData: formData,
        formdataId: id,
        USER_ID: ""
      };
      this.vernostService.editData(array).subscribe(response => {
        console.log("edit:", response)
        if (response != undefined && response[0].status != "Failed") {

          this.removeEditScreen();
          // document.getElementById("errs").innerHTML = 
          this.showMessagePopup("Record Updated Successfully")
          this.screen_details = [];
          this.validflag = false;

        } else {
          // document.getElementById("errs").innerHTML = 
          this.showMessagePopup("Record Not Updated Successfully")
        }
      });

    }
    // }
  }
  searchData(show_error_msg) {

    this.searchlist = false;
    this.loader = true;
    var errs = document.getElementsByClassName("search_err");
    var valid_search_flag = false, valid_search_fields = false;
    for (var e = 0; e < errs.length; e++) {
      var key = errs[e].id;
      console.log("key:", key, ">>>", this.search_details[key])
      if (this.search_details[key] != undefined && this.search_details[key] != "") {
        valid_search_flag = true;
        break;
      }
    }
    for (var searchKey in this.search_details) {

      console.log("searchsearchkey:", searchKey);
      if (this.search_details[searchKey] != undefined && this.search_details[searchKey] != "") {
        valid_search_fields = true;
        break;
      }
    }
    console.log(errs.length, ":::valid_search_flag:", valid_search_flag, "///", valid_search_fields)
    console.log("search_details:", this.search_details)
    var field1 = this.search_details.Travel_Start_Date;
    var field2 = this.search_details.Travel_End_Date;
    var field3 = this.search_details.Cost_Price;
    var field4 = this.search_details.Trip_Type;
    if (
      !valid_search_flag && !valid_search_fields
    ) {
      this.loader = false;
      this.searchDataOnLoad();
      this.searchresult = false;
    } else {
      console.log(field1, "field1");
      if (field1 != undefined && field1.trim() != "") {

        var fields1 = field1.toUpperCase();
      }
      if (field2 != undefined && field2.trim() != "") {
        var fields2 = field2.toUpperCase();
      }
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "" && field1 != undefined) {
        searchitem.push(fields1);
        searchColumn.push("TRAVEL_START");
      }
      if (field2 != "" && field2 != undefined) {
        searchitem.push(fields2);
        searchColumn.push("TRAVEL_END");
      }
      if (field3 != "" && field3 != undefined) {
        searchitem.push(field3);
        searchColumn.push("COST_PRICE");
      }
      if (field4 != "" && field4 != undefined) {
        searchitem.push(field4);
        searchColumn.push("TRIP_TYPE");
      }
      //screen wise filter
      searchitem.push(this.screen_name);
      searchColumn.push("SCREEN_NAME");

      var Data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };

      this.vernostService.searchRecord(Data).subscribe(response => {
        this.loader = false;
        console.log("Searchresponse", response);
        this.searchtabledata = response;
        if (response.length > 0) {
          this.searchresult = true;
          this.searchtabledata = response;
          document.getElementById("errs").innerHTML = "";


        } else {
          this.searchresult = false;
          // document.getElementById("errs").innerHTML = 
          this.showMessagePopup("Record not found");
        }
      });
    }
  }
  showFormData(data, flag) {
    this.EditData = [];
    console.log("data", data);
    this.EditData.push(data);
    console.log("data", this.EditData);

    if (flag == 1) {
      this.editFlag = false;

      this.actionmode = "view";
      this.viewpage = true;


    } else {
      this.editFlag = true;
      this.delete_id = data.ID;

      this.actionmode = "Edit";
      this.screen_details.Travel_Start_Date = data.TRAVEL_START;
      this.screen_details.Travel_End_Date = data.TRAVEL_END;
      this.screen_details.Cost_Price = data.COST_PRICE;
      this.screen_details.Cost_Price_No_GST = data.COST_PRICE_NO_GST;
      this.screen_details.Mark_Up = data.MARKUP;
      this.screen_details.Ploughback = data.PLOUGHBACK;
      this.screen_details.RPM = data.RPM;
      this.screen_details.Commission = data.COMMISSION;
      this.screen_details.Trip_Type = data.TRIP_TYPE;
      this.screen_details.Insurance_Provider = data.INSURANCE_PROVIDER; 
    }
    this.validflag = this.validate();
  }

  num_check(id) {
    this.validflagform[id] = this.commonService.numcheck(this.screen_details[id], id, /^[0-9]+$/);
    this.validflag = this.validate();
  }

  decimal_check(id) {
    this.validflagform[id] = this.commonService.numcheck(this.screen_details[id], id, /^[0-9]+(\.[0-9]+)?$/);
    this.validflag = this.validate();
  }

  blank_check(id) {
    this.validflagform[id] = this.commonService.blankcheck(this.screen_details[id], id);
    this.validflag = this.validate();
  }
  deleteData() {
    var deleteReq = {
      ID: this.delete_id
    };
    this.vernostService.DeleteInsuranceArray(deleteReq).subscribe(response => {
      console.log("Delete:-", response);
      if (response != undefined && response[0]["status"] == "Success") {
        // document.getElementById("errs").innerHTML = 
        this.screen_details = [];

        this.removeEditScreen();

        this.showMessagePopup("Record Deleted Successfully")
      } else {
        // document.getElementById("errs").innerHTML = 
        this.showMessagePopup("Record Not Deleted Successfully")
      }

    });
  }
  removeEditScreen() {

    this.actionmode = "Search";
    this.editFlag = false;
    this.viewpage = false;
    document.getElementById("errs").innerHTML = "";
    this.searchForm(false);
  }
  showMessagePopup(message) {
    document.getElementById("errs").innerHTML = message;
    setTimeout(() => {
      document.getElementById("errs").innerHTML = "";
    }, 2000);
  }
  setScreen(screen) {
    this.screen_name = screen;
    if (this.screen_name == 'ti_dom') {
      this.screen_details.Cost_Price = 199;
    }
    this.actionmode = "Search";
    this.screen_details = [];
    this.editFlag = false;
    this.validflag = false;
    document.getElementById("errs").innerHTML = "";
    this.viewpage = false;
    this.searchresult = false;
    this.search_details = [];
    this.loader = false;
    this.search_details.Trip_Type = '';
    this.searchDataOnLoad();
  }
  
  checkRecordInDB() {
    return new Promise(resolve => {      
      var Data = {
        parent_table: this.parent_table,
        dbFields: ["SCREEN_NAME"],
        searchData: [this.screen_name],
        childtables: this.childtables,
        filters: this.filters
      }
      if (this.screen_name == "zero_canc") {
        Data.dbFields.push("TRAVEL_START");
        Data.searchData.push(this.screen_details.Travel_Start_Date);

        Data.dbFields.push("TRAVEL_END");
        Data.searchData.push(this.screen_details.Travel_End_Date);
      }
      if (this.screen_name != "zero_canc") {
        Data.dbFields.push("TRIP_TYPE");
        Data.searchData.push(this.screen_details.Trip_Type);
      }
      this.vernostService.searchRecord(Data).subscribe(response => {
        this.loader = false;
        console.log("Searchresponse", response);
        // this.searchtabledata = response;
        if (response.length > 0) {
          this.showMessagePopup("Record already exists !");
          resolve(true);
        } else {
          resolve(false);
        }
      });
      // }
    })
  }
  checkLimit(id, minimum, maximum) {
    this.validflagform[id] = this.commonService.checkLimit(id, minimum, maximum, this.screen_details[id], this.validflagform[id]);
    this.validflag = this.validate();
  }

  ceil(number) {
    return Math.ceil(number);
  }
  round(number) {
    return Math.round(number);
  }
  getInsProvider(provider_key) {
    for (var provider of this.providers) {
      if (provider_key == provider.map_id)
        return provider["value"];
    }
    return "";
  }
  getMilesValue(COST_PRICE_NO_GST, COMMISSION, PLOUGHBACK, RPM) {
    var miles = Math.round((((COST_PRICE_NO_GST * COMMISSION / 100) * (PLOUGHBACK / 100)) / (RPM)) / 25) * 25;
    return (miles < 25) ? 25 : miles;
  }


  validate() {
    var errs = document.getElementsByClassName("err");

    for (var e = 0; e < errs.length; e++) {
      var key = errs[e].id.slice(0, -4);
      // console.log("--:",key,">>>",this.screen_details[key],",vald:",this.validflagform[key])
      if (errs[e].className.indexOf("nonmandat") != -1 &&
        (this.screen_details[key] === undefined || this.screen_details[key] === null || this.screen_details[key] === "")) {
        console.log(key, ",this.validflagform[key]:", this.validflagform[key], " && ", this.screen_details[key])
        this.validflagform[key] = true;
      }
      if (this.validflagform[key] == undefined) {
        if (this.screen_details[key] === undefined || this.screen_details[key] == null || this.screen_details[key] === "") {
          this.validflagform[key] = false;
          // console.log("''''flse:",key,">>>",this.screen_details[key])
          return false;
        }
        else {
          this.validflagform[key] = true;
        }
      }
      else {
        if (this.validflagform[key] === false) {
          // console.log("flse:",key,">>>",this.validflagform[key],">>val>>",this.screen_details[key])
          return false;
        }
      }
    }
    return true;
  }


  allowBlank(id) {
    let name = this.screen_details[id];
    if (name == "" //&& regex.test(name) == false
    ) {
      this.validflagform[id] = true;
      document.getElementById(id + "_err").innerHTML = ""
    }
    this.validflag = this.validate();
  }

  set_cost_price_without_gst() {
    if (!isNaN(this.screen_details.Cost_Price)) {
      this.screen_details.Cost_Price_No_GST = (this.screen_details.Cost_Price / 1.18);
      this.allowBlank('Cost_Price_No_GST');
    }
    else {
      this.screen_details.Cost_Price_No_GST = "";
    }

  }
  searchDataOnLoad() {
    this.searchlist = false;
    this.loader = true;
    var searchitem = [];
    var searchColumn = [];
    //screen wise filter
    searchitem.push(this.screen_name);
    searchColumn.push("SCREEN_NAME");

    var data = {
      parent_table: this.parent_table,
      dbFields: searchColumn,
      searchData: searchitem,
      childtables: this.childtables,
      filters: this.filters
    };

    this.vernostService.searchRecord(data).subscribe(resp => {
      this.loader = false;
      this.searchtabledata = resp;
      if (resp.length > 0) {
        this.searchresult = true;
        this.searchtabledata = resp;
        document.getElementById("errs").innerHTML = "";
      } else {
        this.searchresult = false;
        this.showMessagePopup("Record not found");
      }
    });
  }
  deleteDataConfirm() {
    this.showCustomMsg("Delete Confirmation", "Do you really want to delete ?")
  }
  showCustomMsg(custom_header, custom_msg) {
    this.custom_header = custom_header;
    this.custom_msg = custom_msg;
    (<HTMLButtonElement>document.getElementById("updateCustomMsgBtn")).click();
  }
}
